import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Tooltip,
} from "@mui/material";
import NavListDrawer from "./NavListDrawer";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { Box } from "@mui/system";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import useOnlineStatus from "../../Hooks/UseOnlineStatus";
import { useThemeCtx } from "../../ThemeContext";
import swal from "sweetalert";
import Logo from "../../Img/IRON_Logo blanco sin fondo.svg";

const CONTRAST = "#1a0e00";

export default function Navbar({ navegationLinks, children }) {
  const [open, setOpen] = useState(false);
  const isOnline = useOnlineStatus();
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeCtx();

  const logout = () => {
    swal({
      title: "¿Deseas cerrar sesión?",
      text: "Solo podrás volver a ingresar si tenés conexión a internet.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmacion) => {
      if (confirmacion) {
        localStorage.removeItem("usuario");
        localStorage.removeItem("roles");
        localStorage.removeItem("user-token");
        localStorage.removeItem("firma");
        localStorage.removeItem("nombre-Completo");
        navigate("/auth/login");
      }
    });
  };

  return (
    <>
      <AppBar position="sticky">
        <Toolbar sx={{ gap: 0.5 }}>
          <IconButton size="large" onClick={() => setOpen(true)} edge="start"
            sx={{ color: CONTRAST }}>
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <img src={Logo} alt="Iron Group" height={48} width={130} />
          </Box>

          <Typography variant="caption"
            sx={{ color: CONTRAST, opacity: 0.55, mr: 0.5, display: { xs: "none", sm: "block" } }}>
            v1.0.3
          </Typography>

          <Tooltip title={isOnline ? "En línea" : "Sin conexión"}>
            <span>
              {isOnline
                ? <WifiIcon sx={{ color: CONTRAST, fontSize: 20 }} />
                : <WifiOffIcon sx={{ color: CONTRAST, fontSize: 20 }} />}
            </span>
          </Tooltip>

          {/* Toggle de tema */}
          <Tooltip title={mode === "dark" ? "Modo claro" : "Modo oscuro"}>
            <IconButton
              onClick={toggleTheme}
              size="small"
              sx={{
                color: CONTRAST,
                bgcolor: "rgba(0,0,0,0.12)",
                borderRadius: 2,
                width: 34,
                height: 34,
                mx: 0.5,
                "&:hover": { bgcolor: "rgba(0,0,0,0.2)" },
              }}
            >
              {mode === "dark"
                ? <LightModeIcon sx={{ fontSize: 17 }} />
                : <DarkModeIcon  sx={{ fontSize: 17 }} />}
            </IconButton>
          </Tooltip>

          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Button
              onClick={logout}
              sx={{
                color: CONTRAST,
                fontWeight: 500,
                gap: 0.5,
                "&:hover": { bgcolor: "rgba(0,0,0,0.1)" },
              }}
            >
              <ExitToAppIcon sx={{ fontSize: 18 }} />
              Salir
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth={false} sx={{ p: 0 }} disableGutters>
        {children}
      </Container>

      <Drawer open={open} anchor="left" onClose={() => setOpen(false)}>
        <NavListDrawer
          navegationLinks={navegationLinks}
          setOpen={setOpen}
        />
      </Drawer>
    </>
  );
}
